

















































import { JobTake5Check } from '@/models/jobTake5/jobTake5Check';
import User from '@/models/user';
import { vxm } from '@/stores';
import Nullable from '@/types/nullable';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class Take5SafetyPrompt extends Vue {
  @Prop({ type: Object, default: null }) public take5!: Nullable<JobTake5Check>;

  private expanded: boolean = false;
  
  get showSafetyAlert() {
    return this.take5.safety_prompt_1 === false || this.take5.safety_prompt_2 === false || this.take5.safety_prompt_3 === false || 
          this.take5.safety_prompt_1 === 0 || this.take5.safety_prompt_2 === 0 || this.take5.safety_prompt_3 === 0;
  }
  
  textRequired(v: string) {
    if(v == null || v.length == 0){
      return "Cannot be left blank";
    }

    return true;
  }
}

